import { Core, useTranslation } from "@opendash/core";
import { Tag, Tooltip } from "antd";
import React from "react";
import { Kanban_State } from "../../../../js/parsegenerated";

export const TicketStateTag = (props: { state: Kanban_State | undefined }) => {
  const t = useTranslation();
  const isNotEnabled = props.state && !props.state.get("enabled");

  if (!isNotEnabled)
    return (
      <Tag
        color={props.state?.color}
        style={{
          color: props.state?.color
            ? Core.Helpers.Colors.getContrastColorBW(props.state?.color)
            : undefined,
        }}
      >
        {props?.state?.label ?? t("maintenance:kanban.state.notset")}
      </Tag>
    );

  return (
    <Tooltip title={t("maintenance:kanban.state.notenabled")} color="red">
      <Tag color="red" style={{ cursor: "help" }}>
        {props?.state?.label ?? t("maintenance:kanban.state.notset")}
      </Tag>
    </Tooltip>
  );
};
